import React, { Component } from "react";
import "./MainMenuPage.scss";
import Header from "./Header";
import MainMenuOptions from "./MainMenuOptions";
import ExtraOptions from "./ExtraOptions";
// import UserStatistics from "./UserStatistics"; - TODO - Temp Comment for PI LOAD
import { connect } from "react-redux";
import { saveTestUserDetails } from "../../actions";
import $ from "jquery";
import LoaderComponent from "../LoaderComponent";

class MainMenuPage extends Component {
  constructor() {
    super();
    this.state = {
      existingCookie: null,
      isLoading: true,
    };
  }
  componentDidMount() {
    const { cookies } = this.props;
    const existingCookie = cookies.get("app_settings");

    if (!existingCookie) {
      let appSettings = {
        flashcard_settings: {
          // diff: "E",
          diff: "",
        },
        quiz_settings: {
          // diff: "E",
          // questions: "10",
          diff: "",
          questions: "",
        },
        last_quiz: {
          diff: "",
          date: "",
          time: "",
          score: "",
        },
        test_score: {
          date: "",
          time: "",
          score: "",
        },
        best_test_score: {
          date: "",
          time: "",
          score: "",
        },
        user_details: {
          name: "",
          email: "",
          password: "",
        },
      };
      cookies.set("app_settings", appSettings);
    } else {
      this.setState({
        existingCookie,
      });
      this.props.saveTestUserDetails(
        existingCookie.user_details ? existingCookie.user_details : null
      );
    }
    this.setState(
      {
        isLoading: false,
      },
      () => {
        this.interval = setInterval(() => {
          this.resetHeaderPosition();
        }, 10);
        setTimeout(() => {
          clearInterval(this.interval);
        }, 10000);
      }
    );
    window.addEventListener("resize", this.resetHeaderPosition);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resetHeaderPosition);
    clearInterval(this.interval);
  }
  resetHeaderPosition = () => {
    if (document.getElementById("main_header")) {
      let headerHeight = document.getElementById("main_header").offsetHeight;
      $(".page-content").css("padding-top", headerHeight + "px");
    }
  };
  render() {
    const { questionSetDetails } = this.props;
    const { isLoading } = this.state;
    this.resetHeaderPosition();

    return isLoading || !questionSetDetails ? (
      <LoaderComponent loading={isLoading} />
    ) : (
      <div className="main-page-container">
        {questionSetDetails && (
          <React.Fragment>
            <Header questionSetDetails={questionSetDetails} />

            <div className="page-content">
              <div className="page-content-container">
                <MainMenuOptions
                  existingCookie={this.state.existingCookie}
                  questionSetDetails={questionSetDetails}
                />
                {/* TODO - Temp Comment for PI LOAD
                <UserStatistics
                  existingCookie={this.state.existingCookie}
                  questionSetDetails={questionSetDetails}
                />
                */}
                <ExtraOptions />
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    questionSetDetails: state.questionSetDetails,
  };
};

export default connect(mapStateToProps, {
  saveTestUserDetails,
})(MainMenuPage);
